import { Link } from "react-router-dom";

import { matchPath } from "react-router";
import { useTranslation } from "react-i18next";

import {
  Typography,
  useTheme,
  ListItem,
  ListItemButton,
  ListItemText,
  SvgIcon,
} from "@mui/material";

type MenuItemProps = {
  element: {
    path: string;
    key: string;
    icon: any;
    overrideLabel?: string;
  };
  open: boolean;
  onClick?: Function;
  url?: string;
};

export default function MenuItem({
  element,
  open,
  onClick,
  url,
}: MenuItemProps) {
  const isActive = isCurrentElementActive(element);
  const theme = useTheme();
  const { t } = useTranslation();
  const itemStyle = {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
    ...(isActive && {
      backgroundColor: "secondary.main",
      borderLeft: "5px solid white",
    }),
  };

  function handleClick(e: any) {
    if (onClick) {
      onClick(e);
    }
  }

  return (
    <Link
      to={url ? url : element.path}
      onClick={handleClick}
      style={{
        textDecoration: "none",
        color: theme.palette.primary.contrastText,
      }}
    >
      <ListItem disablePadding sx={itemStyle}>
        <ListItemButton
          sx={[
            {
              minHeight: 48,
              px: 2,
            },
          ]}
        >
          <SvgIcon
            fontSize={isActive ? "medium" : "small"}
            sx={{ marginRight: 1.5 }}
          >
            {element.icon}
          </SvgIcon>

          <ListItemText
            primary={
              <Typography
                variant="subtitle1"
                noWrap
                {...(isActive && {
                  fontWeight: "bold",
                  fontSize: '1rem',
                })}
              >
                {element.overrideLabel ?? t(`TITLE.MENU.${element.key}`) }
              </Typography>
            }
            sx={[
              open
                ? {
                    opacity: 1,
                  }
                : {
                    opacity: 0,
                  },
            ]}
          />
        </ListItemButton>
      </ListItem>
    </Link>
  );
}

function isCurrentElementActive(element: any) {
  const match = matchPath({ path: element.path }, window.location.pathname);
  if (match) {
    return true;
  }
  if (element.children && element.children.length > 0) {
    for (var i = 0; i < element.children.length; i++) {
      const matchChild = matchPath(
        { path: element.children[i].path },
        window.location.pathname
      );
      if (matchChild) {
        return true;
      }
    }
  }

  return false;
}
